import React, { useState } from "react";
import { Alert, Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Stack, TextField, Typography } from "@mui/material";
import { Email } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AusbildungNavbar from "./AusbildungNavbar";
import api from "lib/api/api";

const AusbildungDashboard = () => {
  const navigate = useNavigate();
  const [testOpen, setTestOpen] = useState(false);
  const [testEmail, setTestEmail] = useState({
    to: "mina@algermanist.com",
    subject: "ALGermanist Ausbildung email test",
    body: "This is a test email from the Ausbildung dashboard. If you received it, the configured mailbox can send email successfully.\n\nALGermanist Team"
  });
  const [testBusy, setTestBusy] = useState(false);
  const [testResult, setTestResult] = useState(null);

  const sendTestEmail = async () => {
    setTestBusy(true);
    setTestResult(null);
    try {
      const { data } = await api.post("/ausbildung-management/email/test", testEmail);
      setTestResult({ severity: "success", message: data?.message || "Test email sent." });
    } catch (error) {
      setTestResult({ severity: "error", message: error.response?.data?.message || "Test email could not be sent." });
    } finally { setTestBusy(false); }
  };

  return <Box sx={{ bgcolor: "#f5f7f8", minHeight: "100vh" }}>
    <AusbildungNavbar />
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight={900}>Ausbildung Management</Typography>
      <Typography color="text.secondary" sx={{ mt: 1 }}>Review, edit and manage Ausbildung applications, documents and registered interests.</Typography>
      <Alert severity="info" sx={{ mt: 3 }}>This dashboard only displays Ausbildung data.</Alert>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mt: 3 }}>
        <Button variant="contained" onClick={() => navigate("/dashboard/ausbildung/submissions")}>Open applications</Button>
        <Button variant="outlined" onClick={() => navigate("/dashboard/ausbildung/interests")}>Open interests</Button>
        <Button variant="outlined" onClick={() => navigate("/dashboard/ausbildung/rooms")}>Applicant rooms</Button>
        <Button variant="outlined" startIcon={<Email />} onClick={() => { setTestResult(null); setTestOpen(true); }}>Test Mina email</Button>
      </Stack>
    </Container>
    <Dialog open={testOpen} onClose={() => !testBusy && setTestOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Test Ausbildung email mailbox</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Alert severity="info">This sends a real test email from the configured Mina mailbox. You can edit the recipient and message before sending.</Alert>
          {testResult && <Alert severity={testResult.severity}>{testResult.message}</Alert>}
          <TextField fullWidth required type="email" label="Send test to" value={testEmail.to} onChange={event => setTestEmail(current => ({ ...current, to: event.target.value }))} />
          <TextField fullWidth required label="Subject" value={testEmail.subject} onChange={event => setTestEmail(current => ({ ...current, subject: event.target.value }))} />
          <TextField fullWidth required multiline minRows={4} label="Email message" value={testEmail.body} onChange={event => setTestEmail(current => ({ ...current, body: event.target.value }))} />
          <Paper variant="outlined" sx={{ p: 2, bgcolor: "#f8fafc" }}>
            <Typography fontWeight={800}>Email preview</Typography>
            <Typography variant="subtitle2" sx={{ mt: 1 }}>{testEmail.subject}</Typography>
            <Typography variant="body2" sx={{ mt: 1, whiteSpace: "pre-wrap" }}>{testEmail.body}</Typography>
          </Paper>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setTestOpen(false)} disabled={testBusy}>Close</Button>
        <Button variant="contained" startIcon={<Email />} onClick={sendTestEmail} disabled={testBusy || !testEmail.to.trim() || !testEmail.subject.trim() || !testEmail.body.trim()}>{testBusy ? "Sending…" : "Send test email"}</Button>
      </DialogActions>
    </Dialog>
  </Box>;
};

export default AusbildungDashboard;
